import { convertDollarToNumber, isDate } from './utilityFunctions';

const tierOrder = ['Group', 'Team', 'Organization', 'Root'] as const;
const statusOrder = ['Active', 'Invited', 'Removed'] as const;
const invoiceOrder = ['Open', 'Paid', 'Uncollectible', 'Void'] as const;

const getOrderIndex = <T extends readonly string[]>(orderArray: T, value: any): number => {
  const valueStr = String(value || '').toLowerCase();
  const index = orderArray.findIndex(item => valueStr.includes(item.toLowerCase()));
  return index === -1 ? Infinity : index;
};

const sortByDate = (a: string | null | undefined, b: string | null | undefined): number => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return new Date(b).getTime() - new Date(a).getTime();
};

const sortDollars = (a: any, b: any): number => {
  return convertDollarToNumber(a) - convertDollarToNumber(b);
};

const sortByInvoiceStatus = (a: any, b: any): number => {
  return getOrderIndex(invoiceOrder, b) - getOrderIndex(invoiceOrder, a);
};

const sortByAdminStatus = (a: any, b: any): number => {
  return getOrderIndex(statusOrder, b) - getOrderIndex(statusOrder, a);
};

const sortByTier = (a: any, b: any): number => {
  const orderA = getOrderIndex(tierOrder, a);
  const orderB = getOrderIndex(tierOrder, b);

  if (orderA === orderB) {
    return (a || '').localeCompare(b || '');
  }
  return orderB - orderA;
};

const sortAdminStatusThenDate = (a: any, b: any): number => {
  const wordsA = a.status.split(' ');
  const wordsB = b.status.split(' ');

  const statusA = wordsA.find((word: any) => statusOrder.includes(word));
  const statusB = wordsB.find((word: any) => statusOrder.includes(word));
  const statusSort = sortByAdminStatus(statusA, statusB);

  if (statusSort !== 0) return statusSort;

  const dateA = wordsA.find((word: any) => isDate(word));
  const dateB = wordsB.find((word: any) => isDate(word));
  return sortByDate(dateA, dateB);
};

const sortAlphabetically = (a: any, b: any): number => {
  return (a || '').localeCompare(b || '');
};

export {
  sortByDate,
  sortDollars,
  sortByInvoiceStatus,
  sortByAdminStatus,
  sortByTier,
  sortAdminStatusThenDate,
  sortAlphabetically,
};
